/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { inject as service } from '@ember/service';
import EditorConfig from 'embercom/objects/content-editor/content-editor-configuration';
import NotificationMessage from 'embercom/objects/content-editor/notification-message';
import generateViewModeConfig from 'embercom/objects/content-editor/configuration-generators/news-item/view-mode-generator';
import generateEditModeConfig from 'embercom/objects/content-editor/configuration-generators/news-item/edit-mode-generator';
import generateNotificationMessages from 'embercom/objects/content-editor/configuration-generators/standard-notification-messages-generator';
import {
  objectTypes,
  humanReadableObjectNames,
} from 'embercom/models/data/matching-system/matching-constants';

export default function generateEditorConfig(options) {
  options.objectType = objectTypes.newsItem;
  let humanReadableObjectName = humanReadableObjectNames[options.objectType];
  let notificationMessages = generateNotificationMessages(options);
  notificationMessages.activate = generateNewsItemNotificationMessages(
    options.container,
    humanReadableObjectName,
  );
  return EditorConfig.create({
    viewMode: generateViewModeConfig(options),
    editMode: generateEditModeConfig(options),
    notificationMessages,
    requiredFeature: 'news',
  });
}

function generateNewsItemNotificationMessages(container, humanReadableObjectName) {
  return NotificationMessage.extend({
    contentEditorService: service(),
    newsfeedsService: service('newsfeedsService'),
    intl: service(),
    humanReadableObjectName,
    async confirmation() {
      let ruleset = this.contentEditorService.ruleset;
      let newsItem = ruleset.rulesetLinks.firstObject.object;
      let body;

      // Filter selected newsfeeds to not incldue default newsfeed web platform which is added when `Add to your news center` is selected
      let selectedNewsfeed =
        newsItem.newsfeedIds?.filter(
          (newsfeedId) => newsfeedId !== Number(this.newsfeedsService.newsfeedWeb.id),
        ) || [];

      let newsfeedAddedToNewsCenter =
        newsItem.newsfeedIds?.includes(Number(this.newsfeedsService.newsfeedWeb.id)) || false;

      let title = this.intl.t('outbound.news-items.edit.set-live.confirmation.title');
      let confirmButtonText = this.intl.t(
        'outbound.news-items.edit.set-live.confirmation.button-text',
      );

      if (newsfeedAddedToNewsCenter && selectedNewsfeed.length === 0) {
        body = this.intl.t(
          'outbound.news-items.edit.set-live.confirmation.modal-body.empty-add-to-news-center',
        );
      } else if (newsfeedAddedToNewsCenter && selectedNewsfeed.length > 0) {
        body = this.intl.t(
          'outbound.news-items.edit.set-live.confirmation.modal-body.selected-with-news-center',
          {
            newsfeedsCount: selectedNewsfeed.length,
          },
        );
      } else {
        body = this.intl.t(
          'outbound.news-items.edit.set-live.confirmation.modal-body.selected-newsfeeds',
          {
            newsfeedsCount: selectedNewsfeed.length,
          },
        );
      }

      return { title, body, confirmButtonText };
    },
  }).create({
    success: `The ${humanReadableObjectName} was set live`,
    failure: `We couldn't set this ${humanReadableObjectName} live. Send us a message and we'll do our best to help out.`,
    container,
  });
}
